import React, { useCallback } from 'react';
import { useCurrentUser } from '../../common/withUser';
import DropdownItem from "../DropdownItem";
import { useMutation } from "@apollo/client/react";
import { gql } from "@/lib/generated/gql-codegen";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const CommentsListUpdateMutation = gql(`
  mutation updateCommentPinToProfileDropdownItem($selector: SelectorInput!, $data: UpdateCommentDataInput!) {
    updateComment(selector: $selector, data: $data) {
      data {
        ...CommentsList
      }
    }
  }
`);

const styles = defineStyles("PinToProfileDropdownItem", (theme: ThemeType) => ({
  icon: {},
}));

const PinToProfileDropdownItem = ({comment, post}: {
  comment: CommentsList,
  post?: PostsMinimumInfo,
}) => {
  const classes = useStyles(styles);
  const currentUser = useCurrentUser()
  const [updateComment] = useMutation(CommentsListUpdateMutation);
  const togglePinned = useCallback(() => {
    void updateComment({
      variables: {
        selector: { _id: comment._id },
        data: {
          isPinnedOnProfile: !comment.isPinnedOnProfile,
        }
      }
    });
  }, [updateComment, comment]);

  const isCommentAuthor = currentUser?._id === comment.userId
  const userCanPin = isCommentAuthor || currentUser?.isAdmin;
  if (!userCanPin || !post || comment.draft) {
    return null;
  }

  const username = isCommentAuthor
    ? "my"
    : `${comment.user?.displayName}'s`;

  const title = comment.isPinnedOnProfile
    ? `Unpin from ${username} profile`
    : `Pin to ${username} profile`;
  return (
    <DropdownItem
      title={title}
      onClick={togglePinned}
      icon="Pin"
    />
  );
};

export default PinToProfileDropdownItem;

